import { View } from "binder"
import { IntegerViewModel } from "./integer-viewModel"

export class IntegerView extends View<IntegerViewModel>{
    GetViewUniqueId(): string {
        return "V-ACD228A5-DAA5-4E13-94FC-A7932B9F9E06"
    }
    loadHtml(): string {
        let element = require('./integer.html').default;
        let style = require('./integer.less');
        return element;
    }
    constructor() {
       super();
    }
    public set value(v: number) { this._value = v; } public get value(): number { return this._value;} private _value: number;

}
